import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';

import { IErknmFormAgreementExecution } from '../interfaces/IErknmFormAgreementExecution';

export const getAgreementExecutionValidate = (execution: IErknmFormAgreementExecution) => {
  return {
    decision: makeRequired(REQUIRED_ERROR)(execution.decision),
    executionDate:
      execution.decision?.value !== 1 && !execution.decision?.value
        ? undefined
        : makeRequired(REQUIRED_ERROR)(execution.executionDate),
    fioSigner: makeRequired(REQUIRED_ERROR)(execution.fioSigner),
    titleSigner: makeRequired(REQUIRED_ERROR)(execution.titleSigner),
  };
};
